import {PrimaryTenderVariantTr} from "constants/PrimaryTenderVariant";

export default Object.entries(PrimaryTenderVariantTr).map(([value, label]) => ({label, value}))